import { render, staticRenderFns } from "./newStoreData.vue?vue&type=template&id=88b0f850&scoped=true&"
import script from "./newStoreData.vue?vue&type=script&lang=js&"
export * from "./newStoreData.vue?vue&type=script&lang=js&"
import style0 from "./newStoreData.vue?vue&type=style&index=0&id=88b0f850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b0f850",
  null
  
)

export default component.exports